import React from 'react';
import {
  IconButton,
  IconButtonProps
} from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';

export const BackArrowButton = (props: IconButtonProps) => {
  const history = useHistory();
  return (
    <IconButton {...props} onClick={() => history.goBack()}>
      <ArrowBack />
    </IconButton>
  );
};

export default BackArrowButton;
